import { render, staticRenderFns } from "./OfertaSolicitudTable.vue?vue&type=template&id=55568fea&scoped=true&"
import script from "./OfertaSolicitudTable.vue?vue&type=script&lang=js&"
export * from "./OfertaSolicitudTable.vue?vue&type=script&lang=js&"
import style0 from "./OfertaSolicitudTable.vue?vue&type=style&index=0&id=55568fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55568fea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55568fea')) {
      api.createRecord('55568fea', component.options)
    } else {
      api.reload('55568fea', component.options)
    }
    module.hot.accept("./OfertaSolicitudTable.vue?vue&type=template&id=55568fea&scoped=true&", function () {
      api.rerender('55568fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Simuladores/Ofertas/solicitud/OfertaSolicitudTable.vue"
export default component.exports